import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Wheel Overview',
  name: 'wheelOverview',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: [
        {
          type: 'block',
          styles: [],
          lists: [],
          marks: {
            decorators: [
              { title: 'Strong', value: 'strong' },
              { title: 'Emphasis', value: 'em' },
            ],
          },
        },
      ],
    }),
    defineField({
      title: 'Features',
      name: 'features',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
    }),
    defineField({
      title: 'Wheels',
      name: 'wheels',
      type: 'array',
      of: [
        {
          name: 'wheel',
          type: 'object',
          fields: [
            defineField({
              title: 'Design',
              name: 'design',
              type: 'reference',
              to: [{ type: 'design' }],
              options: {
                disableNew: true,
              },
              validation: (rule) => rule.required(),
            }),
            defineField({
              title: 'Wheel Carousel',
              name: 'carousel',
              type: 'wheelLandingCarousel',
            }),
          ],
          preview: {
            select: {
              title: 'design.name',
              diameter: 'carousel.diameter.name',
              profile: 'carousel.profile.name',
              lugs: 'carousel.lugs.name',
              centerCap: 'carousel.centerCap.name',
            },
            prepare({ title, diameter, profile, lugs, centerCap }) {
              return {
                title: `${title}`,
                subtitle: `${diameter} - ${profile} - ${lugs} - ${centerCap}`,
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title: t }) {
      const title = t || 'Wheel Overview'
      const subtitle = !t ? '' : 'Wheel Overview'
      return {
        title,
        subtitle,
      }
    },
  },
})